module.exports = __webpack_public_path__ + "static/media/giftbox.4b5f336a.svg";